export interface FirebaseWebConfig {
  readonly apiKey: string;
  readonly authDomain: string;
  readonly projectId: string;
  readonly messagingSenderId: string;
  readonly appId: string;
  readonly vapidKey: string;
}

function readEnv(value: unknown): string | undefined {
  return typeof value === "string" && value.length > 0 ? value : undefined;
}

/**
 * `null` unless every field is present -- every push entry point checks this
 * first so the feature is a clean no-op until a real Firebase project exists.
 */
export function readFirebaseConfig(): FirebaseWebConfig | null {
  const env = import.meta.env;
  const apiKey = readEnv(env.VITE_FIREBASE_API_KEY);
  const authDomain = readEnv(env.VITE_FIREBASE_AUTH_DOMAIN);
  const projectId = readEnv(env.VITE_FIREBASE_PROJECT_ID);
  const messagingSenderId = readEnv(env.VITE_FIREBASE_MESSAGING_SENDER_ID);
  const appId = readEnv(env.VITE_FIREBASE_APP_ID);
  const vapidKey = readEnv(env.VITE_FIREBASE_VAPID_KEY);

  if (
    apiKey === undefined ||
    authDomain === undefined ||
    projectId === undefined ||
    messagingSenderId === undefined ||
    appId === undefined ||
    vapidKey === undefined
  ) {
    return null;
  }

  return { apiKey, authDomain, projectId, messagingSenderId, appId, vapidKey };
}
